var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#424242;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    transform: "translate(-305.653 -102.949)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M322.3,132H312c-3.3,0-6-2.7-6-6v-17c0.2-3.4,2.8-6,6-6h10.3c3.3,0,6,2.7,6,6v17 C328.3,129.3,325.6,132,322.3,132z M312,107c-1.1,0-1.9,0.9-2,2.1l0,16.9c0,1.1,0.9,2,2,2h10.3c1.1,0,2-0.9,2-2v-17 c0-1.1-0.9-2-2-2H312z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M322.3,150.9H312c-3.3,0-6-2.7-6-6v-4.5c0.2-3.4,2.8-6,6-6h10.3c3.3,0,6,2.7,6,6v4.5 C328.3,148.2,325.6,150.9,322.3,150.9z M312,138.4c-1.1,0-1.9,0.9-2,2.1l0,4.4c0,1.1,0.9,2,2,2h10.3c1.1,0,2-0.9,2-2v-4.5 c0-1.1-0.9-2-2-2H312z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M347.3,150.9H337c-3.3,0-6-2.7-6-6V128c0-3.4,2.6-6,6-6h10.3c3.3,0,6,2.7,6,6v16.9 C353.3,148.2,350.6,150.9,347.3,150.9z M337,126c-1.1,0-2,0.9-2,2v16.9c0,1.1,0.9,2,2,2h10.3c1.1,0,2-0.9,2-2V128c0-1.1-0.9-2-2-2 H337z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M347.3,119.5H337c-3.3,0-6-2.7-6-6V109c0-3.3,2.7-6,6-6h10.3c3.3,0,6,2.7,6,6v4.5 C353.3,116.8,350.6,119.5,347.3,119.5z M337,107c-1.1,0-2,0.9-2,2v4.5c0,1.1,0.9,2,2,2h10.3c1.1,0,2-0.9,2-2V109c0-1.1-0.9-2-2-2 H337z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.5184a9fbef7dbad4e7e78a9feb484ba4.svg";
export { ForwardRef as ReactComponent };